import React from 'react';

const Maiar = () => (
  <svg
    width='31'
    height='31'
    viewBox='0 0 31 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.90625 30.8921L8.45858 23.366L15.9061 15.9097L0.90625 0.892334V30.8921Z'
      fill='url(#paint0_linear_28_2530)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M30.9062 30.8922L23.4062 23.3923L30.9062 15.8923V30.8922Z'
      fill='url(#paint1_linear_28_2530)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.9063 30.8921L8.41504 23.3922L30.9061 0.892334V15.8922L15.9063 30.8921Z'
      fill='white'
    />
    <defs>
      <linearGradient
        id='paint0_linear_28_2530'
        x1='5.40389'
        y1='11.4232'
        x2='10.085'
        y2='16.0925'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#ECECEC' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_28_2530'
        x1='27.7207'
        y1='21.8896'
        x2='30.0608'
        y2='24.2224'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#ECECEC' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
    </defs>
  </svg>
);

export default Maiar;
